import * as React from 'react';

import { Grid, Typography, makeStyles } from '@material-ui/core';
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import MobileScreenShareOutlinedIcon from '@mui/icons-material/MobileScreenShareOutlined';

import telegram from '../../../../../../public/assets/images/op/telegram.png';
import instagram from '../../../../../../public/assets/images/op/instagram.png';
import linkedin from '../../../../../../public/assets/images/op/linkedin.png';
import twitter from '../../../../../../public/assets/images/op/x.png';
import facebook from '../../../../../../public/assets/images/op/facebook.png';
import whatsapp from '../../../../../../public/assets/images/op/whatsapp.png';
import Image from 'next/image';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#fff',
    boxShadow: '0px 2px 15px 0px #0001',
    borderRadius: '10px',
    margin: '10px auto',
    padding: '20px',
  },
  t1: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#292929',
    marginTop: 14,
  },
  t2: {
    fontSize: 16,
    color: '#292929',
    marginTop: 14,
    paddingLeft: 35,
  },
  icon: {
    fontSize: 27,
    color: '#FF5666',
    marginBottom: '-10px',
  },
  image: {
    cursor: 'pointer',
  },
  link: {
    fontSize: 16,
    color: '#292929',
  },
}));

const social = {
  facebook,
  instagram,
  linkedin,
  telegram,
  twitter,
  whatsapp,
};

const OrganizationContact = ({ data, getData, ...props }) => {
  const classes = useStyles();
  console.log(data, 'mitso');

  return (
    <Grid container className={classes.container}>
      {data.address && (
        <Grid item xs={12}>
          <Typography variant="h4" className={classes.t1}>
            <PinDropOutlinedIcon className={classes.icon} /> آدرس
          </Typography>
          <Typography variant="h5" className={classes.t2}>
            {data.address}
          </Typography>
        </Grid>
      )}
      {data.phones && data.phones.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h4" className={classes.t1}>
            <PhoneEnabledOutlinedIcon className={classes.icon} /> تلفن
          </Typography>
          {data.phones.map(item => (
            <Typography variant="h5" className={classes.t2} key={`phone-${item.id}`}>
              {(item.name && item.name !== 'undefined') || 'تلفن'}: {item.phone}
            </Typography>
          ))}
        </Grid>
      )}
      {data.sites && data.sites.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h4" className={classes.t1}>
            <LanguageOutlinedIcon className={classes.icon} /> سایت
          </Typography>
          {data.sites.map(item => (
            <Typography variant="h5" className={classes.t2} key={`site-${item.id}`}>
              {(item.name && item.name !== 'undefined') || 'سایت'}:{' '}
              <a href={item.url} className={classes.link} target="_blank">
                {item.url}
              </a>
            </Typography>
          ))}
        </Grid>
      )}
      {data.email && data.email.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="h4" className={classes.t1}>
            <MailOutlineOutlinedIcon className={classes.icon} /> ایمیل
          </Typography>
          {data.email.map(item => (
            <Typography variant="h5" className={classes.t2} key={`site-${item.id}`}>
              {(item.name && item.name !== 'undefined') || 'ایمیل'}:{' '}
              <a href={`mailto:${item.email}`} className={classes.link} target="_blank">
                {item.email}
              </a>
            </Typography>
          ))}
        </Grid>
      )}
      <Grid item xs={12} container>
        <Grid item xs={12}>
          <Typography variant="h4" className={classes.t1}>
            <MobileScreenShareOutlinedIcon className={classes.icon} /> شبکه‌های اجتماعی
          </Typography>
        </Grid>
        <Grid item xs={5} container>
          {data.social_media &&
            Object.keys(data.social_media).map(item =>
              data.social_media[item] ? (
                <Grid item xs={2} key={`social-${item}`} style={{ marginTop: 20 }}>
                  <a href={data.social_media[item]} target="_blank">
                    <Image src={social[item]} alt={item} placeholder="blur" className={classes.image} width={35} height={35} />
                  </a>
                </Grid>
              ) : null
            )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrganizationContact;
